import {Grid, IconButton, Typography} from '@logistics-frontend/blocks'
import React, {useState} from 'react'

import {ContentBarcodeItem} from 'src/api/cargo-c2c'
import {tagToUrl} from 'src/utils'

import * as classes from './Barcode.classes'
import {BarcodeSvg} from './BarcodeSvg'
import {Modal} from './modal'
import {getContentSections} from './utils'

type Props = {item: ContentBarcodeItem}

export function Barcode({item}: Props): React.ReactElement<Props> {
  const {action, barcode, orientation, subtitle, trail_image_tag} = item
  const contentSections = getContentSections(action)
  const [isModalOpened, setIsModalOpened] = useState(false)
  const openModal = setIsModalOpened.bind(null, true)
  const closeModal = setIsModalOpened.bind(null, false)

  return (
    <>
      <Grid direction="column" size="s" container>
        <Grid onPress={openModal} item>
          <BarcodeSvg text={barcode.barcode} vertical={orientation === 'vertical'} />
        </Grid>
        {subtitle || trail_image_tag ? (
          <Grid alignItems="center" justify="space-between" size="xs" container item>
            {subtitle && (
              <Grid item>
                <Typography color="minor" group="tight" thickness="regular" variant="caption1">
                  {subtitle}
                </Typography>
              </Grid>
            )}
            {trail_image_tag && (
              <Grid item>
                <IconButton onPress={openModal} size="xs" variant="ghost">
                  <img alt="" className={classes.trailImage} src={tagToUrl(trail_image_tag)} />
                </IconButton>
              </Grid>
            )}
          </Grid>
        ) : null}
      </Grid>
      {isModalOpened && contentSections && <Modal contentSections={contentSections} onClose={closeModal} />}
    </>
  )
}
